import React, {useState, useEffect} from 'react';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { Checkbox } from 'primereact/checkbox';
import { Divider } from 'primereact/divider';
import { Chip } from 'primereact/chip';
import { InputTextarea } from 'primereact/inputtextarea';
import { Image } from "primereact/image";
import { storage } from '../../helpers/storage';

const initialForm = {
    observation: "",
    btonAprobar: null,
    btonRechazar: null
}

const FormValidation = ({dataForm, handleCerrarValidacion}) => {

    const [form, setForm] = useState(initialForm);
    const [errors, setErrors] = useState(false);

    const [loadingReasons, setLoadingReasons] = useState(null);
    const [reasons, setReasons] = useState(null);

    const [loadingDatail, setLoadingDetail] = useState(null);
    const [detail, setDetail] = useState(null);
    
    const [checkboxValue, setCheckboxValue] = useState([]);
    
    const [alumno, setAlumno] = useState(null);
    const [prendas, setPrendas] = useState(null);
    
    const [frontal, setFrontal] = useState(null);
    const [reverso, setReverso] = useState(null);
    const [firma, setFirma] = useState(null);
    const [comprobante, setComprobante] = useState(null);

    const ciclo = storage.get('ciclo')
    
    let url = `${BASE_API}Entrega/MotivoCancelacion`;
    useEffect(() => {
        setLoadingReasons(true);
        helpHttp().post(url, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if(res.SUCCESS) {

                let oReasons = res.ITEMS;

                setReasons(oReasons);
            } else {
                setReasons(null);
            }
            setLoadingReasons(false);
        });
    }, [url]);

    useEffect(() => {
        if(dataForm.IdAlumno !== undefined) {
            setLoadingDetail(true);
            helpHttp().post(`${BASE_API}DetalleEntrega/ObtenerDetalleEntrega/${dataForm.IdAlumno}?IdCicloEscolar=${ciclo.IdCicloEscolar}`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if(parseInt(res.IdAlumno)>0) {
                    setAlumno(res);
                    setPrendas(res.PrendasActivas);
                    
                    getImagen(res.IdDocFrontal).then(x => setFrontal(x));
                    getImagen(res.IdDocReverzo).then(x => setReverso(x));
                    getImagen(res.IdDocFirma).then(x => setFirma(x));

                    if(res.IdComprobante > 0) {
                        getImagen(res.IdComprobante).then(x => setComprobante(x));
                    }
                } else {
                    setAlumno(null);
                }
                setLoadingDetail(false);
            });
        } else {
            //alert("jalo fuera");
        }
    }, [dataForm.IdAlumno ]);

    const getImagen = (IdDoc) => {
        let imagen = helpHttp().post(`${BASE_API}DetalleEntrega/ObtenerImagen/${IdDoc}`, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        })
        return imagen;
    }

    const setDisplayAviso = () => {
        //setAviso(false);
    }

    const onCheckboxChange = (e) => {
        let selectedValue = [...checkboxValue];
        if (e.checked)
            selectedValue.push(e.value);
        else
            selectedValue.splice(selectedValue.indexOf(e.value), 1);

        setCheckboxValue(selectedValue);
    };

    const handleChange = (e) => {
		const { name, value } = e.target;

		setForm({
			...form,
			[name]: value,
		});
	};

    const handleBlur = (e) => {
		handleChange(e);
		setErrors(validationsFrom(form));
	};

    const validationsFrom = (form) => {

        let errors = {};
    
        if(form.btonRechazar === 'rechazar' && form.btonAprobar === null) {
            if(checkboxValue.length === 0){
                errors.motivo = "Debe seleccionar al menos un motivo de rechazo";
            }

            if(!form.observation.trim()) {
                errors.observation = "El Campo (Observación) es requerido";
            }
        }
       
        return errors;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setErrors(false);
        setErrors(validationsFrom(form));
        if (Object.keys(errors).length === 0) {
                    
            const arrBody = {
                IdEstatus: (form.btonAprobar === 'aprobar' && form.btonRechazar === null ? 2:3),
                Comentario: form.observation,
                Folio: dataForm.Folio,
                IdCatMotivoCancelacion: checkboxValue.toString(),
                UsuarioCreacion: storage.get('id')
            };

            if(form.btonRechazar === 'rechazar' && form.btonAprobar === null && checkboxValue.length > 0 && form.observation.trim()) {
                submit(arrBody);
            } else if(form.btonAprobar === 'aprobar') {
                submit(arrBody);
            } 
                
        } else {
            return;
        }
    }

    const submit = (arrBody) => {
        helpHttp().post(`${BASE_API}Entrega/SpdRelInsertarValidacion0`, {
                body: arrBody,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then((res) => {
                if(res.SUCCESS) {
                    setCheckboxValue([]);
                    setForm(initialForm);
                    handleCerrarValidacion(arrBody.Folio);
                } else {
                    console.log("Ocurrió un error al intentar realizar este proceso");
                }
            });
    }

    return (
        <div className="grid">
            <div className="col-5 flex justify-content-center">
                <form onSubmit={handleSubmit} className="p-fluid">
                    <div className="field">
                        <label className="custom-control-label" htmlFor="customCheck1">Motivo Rechazo:</label>
                        {errors.motivo && <p className="p-error">{errors.motivo}</p>}
                        {(reasons !== null && reasons.map(item => 
                            <div className="custom-control custom-checkbox" key={`div-${item.idMotivo.toString()}`}>
                                <Checkbox 
                                    name="reason_cancellation" 
                                    value={item.idMotivo}
                                    checked={checkboxValue.indexOf(item.idMotivo) !== -1} 
                                    onChange={onCheckboxChange}
                                    key={item.idMotivo}
                                    className={errors.motivo && 'p-invalid'} />

                                <label className="custom-control-label" key={`label-${item.idMotivo.toString()}`}  htmlFor="customCheck1">&nbsp;{item.Motivo}</label>
                            </div>)
                        )}
                    </div>
                    <div className="field">
                        <div className="form-group">
                            <label htmlFor="observation">Observación:</label>
                            <InputTextarea id="observation" name="observation" value={form.observation} onChange={handleChange} onBlur={handleBlur} className={errors.observation && 'p-invalid'}  autoResize rows="3" cols="30" />
                            {errors.observation && <p className="p-error">{errors.observation}</p>}
                        </div>
                    </div>

                    <div className="flex pt-3">
                        <div className="w-6 pr-2">
                            <button className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" name="btonRechazar" value="rechazar" onClick={handleChange}>
                                <span className="p-button-label p-c">&nbsp;</span>Rechazar
                            </button>
                        </div>
                        <div className="w-6 pl-2">
                            <button className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" name="btonAprobar" value="aprobar"  onClick={handleChange}>
                                <span className="p-button-label p-c">&nbsp;</span>Aprobar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div className="col-1">
                <Divider layout="vertical">
                    <b>Evidencias</b>
                </Divider>
            </div>
            <div className="col-5 align-items-center justify-content-center">
                <div className="card surface-section text-center">
                    <div className="mb-3 font-bold">
                        <span className="text-900">ALUMNO: {alumno?.NombreAlumno}</span>
                    </div>
                    <div className="mb-3 font-bold">
                        <span className="text-700">TUTOR: {alumno?.NombreTutor}</span>
                    </div>
                    <div className="font-bold mb-1">
                        <span className="text-blue-600">ENTRAGADO: {alumno?.Fecha}</span>
                    </div>

                    <div className="text-700 text-sm mb-6">
                        {prendas && prendas?.map((el, index) => 
                            <Chip label={`${el.Prenda}: ${el.Talla}`} className="mr-2 mb-2" key={index} />
                        )}
                    </div>
                </div>

                <Divider align="right">
                    <span className="p-tag">Frontal</span>
                </Divider>

                <Image src={frontal} alt="frontal" width={400} preview />

                <Divider align="right">
                    <span className="p-tag">Reverso</span>
                </Divider>

                <Image src={reverso} alt="reverso" width={400} preview />

                <Divider align="right">
                    <span className="p-tag">Comprobante</span>
                </Divider>

                <Image src={comprobante} alt="comprobante" width={400} preview />
               
                <Divider align="right">
                    <span className="p-tag">Firma</span>
                </Divider>

                <Image src={firma} alt="firma" width={400} preview />

            </div>
        </div>
       
    );
}

export default FormValidation;